import { render, staticRenderFns } from "./houseproperty.vue?vue&type=template&id=1775b322&"
import script from "./houseproperty.vue?vue&type=script&lang=js&"
export * from "./houseproperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports